/**
 * Author：brand
 * Creation Time：2019-05-13 13:07
 * Email：brandhuang@qq.com
 */

const _importFile = require('./import_file')

export const routerMap = {
  layout: _importFile('Layout/index'),                       // layout布局
  login: _importFile('Login/login'),                         // 登录
  register: _importFile('Login/register'),                   // 注册
  forget: _importFile('Login/forget'),                        // 忘记密码
  authLogin: _importFile('Login/autoLogin/index'),                        // 自动登录

  error404: _importFile('Error/404'),                        // 404
  errorExpire: _importFile('Error/expire'),                        // 系统到期
  errorNoRouter: _importFile('Error/no-route'),                        // 未添加菜单

  // 首页
  indexLayout: _importFile('Index/index-layout'),                         // 首页-layout
  index: _importFile('Index/index'),                         // 首页
  indexDetail: _importFile('Index/service-detail'),                         // 首页-客服详情

  // 工作报表
  report: _importFile('WorkReport/report-index'),              // 工作报表-index
  reportLeaveWords: _importFile('WorkReport/report-leavewords'),              // 工作报表-留言报表
  reportShopData: _importFile('WorkReport/report-shopdata'),              // 工作报表-商城数据
  todayReportView: _importFile('WorkReport/report-todayReport'),              // 工作报表-今日数据
  reportOverView: _importFile('WorkReport/report-overview'),                // 工作报表-数据总览
  reportStatistics: _importFile('WorkReport/report-service'),                 // 报表统计
  reportServiceWorkReport: _importFile('WorkReport/report-service-workreport'),                 // 报表统计-回复解决率
  reportServiceQualityReport: _importFile('WorkReport/report-service-qualityreport'),                 // 报表统计-满意度报表
  reportWebsite: _importFile('WorkReport/report-website'),                 // 工作报表-访问轨迹
  keywordData: _importFile('WorkReport/keywordData/index'),                 // 工作报表-关键词统计

  //历史会话
  historyChat: _importFile('History/history-index'),                 // 历史会话

  // 客服管理
  service: _importFile('Service/service-index'),              // 客服管理-index
  serviceAll: _importFile('Service/service-all'),              // 客服管理-全部客服
  serviceAddEdit: _importFile('Service/service-add-edit'),              // 客服管理-添加编辑客服
  serviceRoleSetting: _importFile('Service/service-role-setting'),              // 客服管理-角色设置
  serviceRoleSettingList: _importFile('Service/service-role-list'),              // 客服管理-角色列表
  serviceRoleSettingAddEdit: _importFile('Service/service-role-add-edit'),              // 客服管理-角色添加编辑
  serviceQuality: _importFile('Service/service-qualityreport'),              // 客服管理-评价统计
  serviceTodayActivity: _importFile('Service/service-today-activity'),              // 今日客服活动

  //工单管理
  order: _importFile('order/order-index'), 
  toBeProcessedOrder: _importFile('order/tobeprocessed-order'), // 待处理工单
  toBeProcessedOrderList: _importFile('order/tobeprocessed-order-list'), // 待处理工单
  resolvedOrder: _importFile('order/resolved-order'),// 已解决工单
  resolvedOrderList: _importFile('order/resolved-order-list'),// 已解决工单
  closedOrder: _importFile('order/closed-order'), //已关闭工单
  closedOrderList: _importFile('order/closed-order-list'), //已关闭工单
  workOrderDetail: _importFile('order/workOrderDetail'), //工单详情

  // 企业账户
  business: _importFile('BusinessAccount/business-index'),              // 企业账户-index
  businessCurrent: _importFile('BusinessAccount/business-current'),              // 企业账户-index
  businessContacts: _importFile('BusinessAccount/business-contacts'),              // 企业账户-联系人
  businessService: _importFile('BusinessAccount/business-service'),              // 企业账户-当前服务
  businessServiceRecord: _importFile('BusinessAccount/business-operate-record'),              // 企业账户-当前服务-操作记录
  businessTeam: _importFile('BusinessAccount/business-team'),              // 企业账户-团队信息

  // 设置
  setting: _importFile('Setting/setting-index'),                 // 设置-index
  settingSystem: _importFile('Setting/system/setting-system-index'),                 // 设置-系统设置-index
  settingVisitorInfo: _importFile('Setting/system/setting-visitorInfo'),                 // 设置-系统设置--访客信息
  settingPersonalAccount: _importFile('Setting/system/setting-personal-account'),                 // 设置-系统设置--个人账号设置
  settingUserInfo: _importFile('Setting/system/setting-userinfo'),                 // 设置-系统设置--用户信息
  settingUserInfoAccount: _importFile('Setting/system/userinfo/info-account'),                 // 设置-系统设置--用户信息-账号信息
  settingUserInfoUser: _importFile('Setting/system/userinfo/info-user'),                 // 设置-系统设置--用户信息-个人信息
  settingShopConfig: _importFile('Setting/system/setting-shopconfig'),                 // 设置-系统设置--购物设置


  settingChangePwd: _importFile('Setting/system/setting-change-pwd'),                 // 设置-系统设置--修改密码
  settingNotice: _importFile('Setting/system/setting-notice'),                 // 设置-系统设置--通知中心
  companyNotice: _importFile('Setting/system/company-notice'),                 // 设置-系统设置--公司公告

  settingOnline: _importFile('Setting/online/setting-online-index'),                 // 设置-在线设置--index
  settingOnlineBase: _importFile('Setting/online/setting-online-base'),                 // 设置-在线设置--基础设置

  settingOnlineLeaveMsg: _importFile('Setting/online/setting-online-leave-msg'),   // 设置-在线设置--留言设置
  settingOnlineSatisfaction: _importFile('Setting/online/setting-online-satisfaction'),   // 设置-在线设置--满意度设置
  settingOnlineChatOvertime: _importFile('Setting/online/setting-online-chat-overtime'),   // 设置-在线设置--会话超时
  settingOnlineMsgVocie: _importFile('Setting/online/setting-online-msg-voice'),   // 设置-在线设置--消息声音
  settingOnlineLineUp: _importFile('Setting/online/setting-online-lineup'),   // 设置-在线设置--访客排队

  settingOnlineDistribution: _importFile('Setting/online/setting-online-distribution'),                 // 设置-在线设置--会话分配
  settingOnlineDistributionSetting: _importFile('Setting/online/distribution/distribution-index'),                 // 设置-在线设置--会话分配-设置
  settingOnlineDistributionRules: _importFile('Setting/online/distribution/distribution-rules'),                 // 设置-在线设置--会话分配-规则
  settingOnlineDistributionSort: _importFile('Setting/online/distribution/distribution-sort'),                 // 设置-在线设置--会话分配-排序
  settingOnlineChatBox: _importFile('Setting/online/setting-online-chat'),                 // 设置-在线设置--会话框设置
  settingOnlineWhiteList: _importFile('Setting/online/setting-online-whiteList'),                 // 设置-在线设置--会话白名单 系统防外链设置


  settingJoin: _importFile('Setting/join/setting-join-index'),                 // 设置-接入设置-index
  settingJoinWebsite: _importFile('Setting/join/setting-join-website'),                 // 设置-接入设置-网站接入
  settingJoinWebsiteWeb: _importFile('Setting/join/chatbutton/website'),                 // 设置-接入设置-网站接入
  settingJoinWebsitePc: _importFile('Setting/join/chatbutton/pc'),                 // 设置-接入设置-网站接入-pc按钮样式
  settingJoinWebsiteMob: _importFile('Setting/join/chatbutton/mobile'),                 // 设置-接入设置-网站接入-移动端按钮样式
  settingJoinWxapp: _importFile('Setting/join/setting-join-wxapp'),                 // 设置-接入设置-小程序接入
  settingJoinWeibo: _importFile('Setting/join/setting-join-weibo'),                 // 设置-接入设置-微博接入
  settingJoinGzh: _importFile('Setting/join/setting-join-gzh'),                 // 设置-接入设置-公众号接入
  settingJoinGzhMenu: _importFile('Setting/join/gzh/gzh-menu'),                 // 设置-接入设置-公众号接入-微信菜单
  settingJoinGzhReply: _importFile('Setting/join/gzh/gzh-reply'),                 // 设置-接入设置-公众号接入-自动回复


  settingAdvanced: _importFile('Setting/advanced/setting-advanced-index'),                 // 设置-高级设置-index
  settingAdvancedMsg: _importFile('Setting/advanced/setting-advanced-msg'),                 // 设置-高级设置-短信服务
  settingAdvancedMsgRecordSend: _importFile('Setting/advanced/message/message-record-send'),                 // 设置-高级设置-短信服务-发送记录
  settingAdvancedMsgRecordRecharge: _importFile('Setting/advanced/message/message-record-recharge'),                 // 设置-高级设置-短信服务-充值记录
  settingAdvancedMsgRecharge: _importFile('Setting/advanced/message/message-recharge'),                 // 设置-高级设置-短信服务-充值
  settingAdvancedMass: _importFile('Setting/advanced/setting-advanced-mass'),                 // 设置-高级设置-群发


  settingAdvancedBlackList: _importFile('Setting/advanced/setting-advanced-black-list'),                 // 设置-高级设置-黑名单
  settingAdvancedBlackListSetting: _importFile('Setting/advanced/blacklist/blacklist-index'),                 // 设置-高级设置-黑名单-设置
  settingAdvancedVisitorBlackList: _importFile('Setting/advanced/blacklist/visitor-blacklist'),                 // 设置-高级设置-访客黑名单
  settingAdvancedIpBlackList: _importFile('Setting/advanced/blacklist/ip-blacklist'),                 // 设置-高级设置-ip黑名单

  settingAdvancedChatInvite: _importFile('Setting/advanced/setting-advanced-chat-invite'),                 // 设置-高级设置-对话邀请

  settingAdvancedKnowledge: _importFile('Setting/advanced/setting-advanced-knowledge'),                 // 设置-高级设置-知识库
  settingAdvancedKnowledgeAddOrEdit: _importFile('Setting/advanced/knowledge/knowledge-addEdit'),       // 设置-高级设置-知识库添加编辑
  settingAdvancedKnowledgeManagement: _importFile('Setting/advanced/knowledge/knowledge-management'),                 // 设置-高级设置-知识库-知识库管理
  settingAdvancedKnowledgeCategory: _importFile('Setting/advanced/knowledge/knowledge-category'),                 // 设置-高级设置-知识库-分类列表
  settingAdvancedGreetLibrary: _importFile('Setting/advanced/setting-advanced-greetLibrary'),                 // 设置-高级设置-机器人寒暄库

  settingAdvancedReply: _importFile('Setting/advanced/setting-advanced-reply'),                 // 设置-高级设置-快捷回复
  settingAdvancedCompanyReply: _importFile('Setting/advanced/reply/company-reply'),                 // 设置-高级设置-快捷回复-企业回复
  settingAdvancedPersonalReply: _importFile('Setting/advanced/reply/personal-reply'),                 // 设置-高级设置-快捷回复-个人回复
  settingAdvancedReplyCategory: _importFile('Setting/advanced/reply/category-list'),                 // 设置-高级设置-快捷回复-分类列表

  settingAdvancedRobot: _importFile('Setting/advanced/setting-advanced-robot'),                 // 设置-高级设置-机器人

  settingAdvancedTag: _importFile('Setting/advanced/setting-advanced-tag'),                 // 设置-高级设置-标签

  settingAdvancedVoice: _importFile('Setting/advanced/setting-advanced-voice'),                 // 设置-高级设置-语音设置



  settingAdvancedQRCode: _importFile('Setting/advanced/setting-advanced-qrcode'),                 // 设置-高级设置-二维码名片
}
